import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'HighlightText',
})(({ brandColors, spacing }, props) => ({
  container: {
    '&.style-overrides': {
      paddingBottom: spacing(2),
    },
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),
  },
  eyebrow: {
    paddingTop: spacing(0),
    paddingBottom: spacing(-1),
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
  },
  headline: {
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
  textCenter: {
    textAlign: 'center',
  },
}));

export default useStyles;
